"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
/* eslint-disable max-len */
var _default = exports["default"] = 'M12 3c4.977 0 9 4.023 9 9s-4.023 9-9 9-9-4.023-9-9 4.023-9 9-9zm-.955 9.122l-3.598 3.599a.675.675 0 1 0 .955.954L12 13.078l3.598 3.598a.676.676 0 0 0 .954-.954l-3.598-3.599 3.598-3.598a.675.675 0 0 0-.954-.955L12 11.168 8.402 7.569a.675.675 0 1 0-.955.955l3.598 3.598z';